import { NgModule } from '@angular/core';
import { InMemoryCache } from '@apollo/client/core';
import { APOLLO_NAMED_OPTIONS, NamedOptions } from 'apollo-angular';
import { HttpLink } from 'apollo-angular/http';
import { AppConfigService } from 'src/app/services/app.config.service';

export const createNamedApollo = (
    httpLink: HttpLink,
    appConfig: AppConfigService
): NamedOptions => {
    const gateway: { url: string, endpoints: string[] } = appConfig.get('gateway');
    let namedOptions: NamedOptions = {};
    gateway.endpoints.forEach(endpoint => {
        namedOptions[endpoint] = {
            cache: new InMemoryCache(),
            link: httpLink.create({
                uri: endpoint === 'api/user' ? `${appConfig.get('vendorOnboarding.mssqlGraphqlUrl')}/api/user` : `${gateway.url}/${endpoint}`,
            }),
        }
    });
    return namedOptions;
};

@NgModule({
    providers: [
        {
            provide: APOLLO_NAMED_OPTIONS,
            useFactory: createNamedApollo,
            deps: [HttpLink, AppConfigService],
        }
    ],
})
export class GraphQLModule { }
